<template>
  <div class="row py-3" style="background-color:white; width:99.85%">
    <div class="col-md-2 col-sm-12 col-spacing student-spacing center">
      <div class="data-name">
        Edad:
      </div>
      <div class="font-weight-normal color-black">
        {{
          additionalInfo !== null && additionalInfo.age !== null
            ? additionalInfo.age
            : '-'
        }}
      </div>
    </div>
    <div class="col-md-2 col-sm-12 col-spacing student-spacing">
      <div class="data-name">
        Tipo de Escuela:
      </div>
      <div class="font-weight-normal color-black">
        {{
          additionalInfo !== null && additionalInfo.schoolType !== null
            ? additionalInfo.schoolType
            : '-'
        }}
      </div>
    </div>
    <div class="col-md-2 col-sm-12 col-spacing student-spacing">
      <div class="data-name">
        Grupo de Edad:
      </div>
      <div class="font-weight-normal color-black">
        {{
          additionalInfo !== null && additionalInfo.ageGroup !== null
            ? additionalInfo.ageGroup
            : '-'
        }}
      </div>
    </div>
    <div class="col-md-4 col-sm-12 col-spacing student-spacing">
      <div class="data-name">
        Número de Grant:
      </div>
      <div class="font-weight-normal color-black">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="selectPurchaseOrder"
            :clearable="false"
            custom-error-msg="Favor de seleccionar una cifra de cuenta."
            :disabled="additionalInfo.checkedFlag && !editing"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            :options="purchaseOrders"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
    </div>
    <div
      v-if="canEdit"
      class="col-md-2 col-sm-12 col-spacing student-spacing mt-4"
    >
      <action-button
        v-if="!editing"
        i="far fa-edit"
        variant="success mx-2"
        @click="editNumber()"
      />
      <action-button
        v-if="editing"
        i="fas fa-times-circle"
        variant="outline-danger mx-2"
        @click="cancel()"
      />
      <action-button
        v-if="editing"
        class="success"
        i="far fa-save"
        variant="success mx-2"
        @click="saveChange()"
      />
    </div>
    <error
      v-if="!isValidGrant"
      class="pt-2 ml-2"
      is-alert-mode
      message="La cifra de cuenta seleccionada no corresponde a este servicio. Te recomendamos verificar y seleccionar la cifra correcta."
      variant="no-border"
    />
  </div>
</template>
<script>
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import billingStatus from '@/utils/constants/billingStatus.js';
import Error from 'custom-error';

const accountTypeValues = Object.freeze({
  Federal: 1,
  Estatal: 2,
});

export default {
  name: 'AdditionalPurchaseOrder',
  components: { CustomDropDown, ActionButton, Error },
  mixins: [],
  props: {
    additionalInfo: {
      type: Object,
      default: () => {},
    },
    purchaseOrders: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => {},
    },
    billStatus: {
      type: Number,
      default: () => null,
    },
    isFederalNumber: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    editing: false,
    originalValue: null,
  }),
  computed: {
    selectPurchaseOrder: {
      get: function() {
        return this.value;
      },
      set: function(value) {
        this.$emit('update', value);
      },
    },
    canEdit() {
      return (
        this.billStatus != billingStatus.EnProcesoIntervencion &&
        this.billStatus != billingStatus.EnProcesoIntervencionObjetada &&
        this.userHasPermissions('provider.billing.number')
      );
    },
    isValidGrant() {
      if (
        this.selectPurchaseOrder == null ||
        this.selectPurchaseOrder.figureTypeId === accountTypeValues.Estatal
      )
        return true;

      return (
        this.additionalInfo.ageGroupId ===
        this.selectPurchaseOrder.billingServiceCategoryId
      );
    },
  },
  mounted() {
    this.originalValue = this.value;
  },
  methods: {
    editNumber() {
      this.editing = true;
    },
    cancel() {
      this.$emit('update', this.originalValue);
      this.editing = false;
    },
    saveChange() {
      this.$emit('save');
      this.editing = false;
    },
  },
};
</script>
